import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>404 - Pagina non trovata</h1>
      <p>La pagina che stai cercando non esiste.</p>
    </div>
  );
};

export default NotFound;